import React, { useEffect, useState } from "react";
import useStore from "@/stores/index";
import { useClassroomPolicyStore } from "@/stores/v2/classroomPolicyStore";
import { ChatButton } from "./ChatButton";
import { ClassroomDetails } from "@/stores/classroomStore_I";

interface Props {
	handleClick: () => void;
	classroom: ClassroomDetails;
	chatDisabled?: boolean;
}

const ChatToolbarButton = (props: Props): JSX.Element => {
	const [hasUnreadMessages, setHasUnreadMessages] = useState(false);
	const classroomIdForChat = props.classroom?.name;

	useEffect(() => {
		const unsubMessageOverview = useStore.subscribe(
			// @ts-expect-error - Leaving code as it is
			(state) => state.chat.unreadMessagesCount,
			(newState) => {
				// @ts-expect-error - Leaving code as it is
				if (newState.data) {
					setHasUnreadMessages(
						// @ts-expect-error - Leaving code as it is
						Object.values(newState.data).some(
							// @ts-expect-error - Leaving code as it is
							(item) => item.hasUnreadMessages && item.classroomId === classroomIdForChat
						)
					);
				}
			}
		);

		return () => {
			unsubMessageOverview();
		};
	}, [classroomIdForChat]);
	const isChatEnabled = useClassroomPolicyStore.getState().isChatBlocked() === false;
	const isClassroomActive = useStore.getState().classroom.isActiveV2(props.classroom.sourceId);

	return (
		<ChatButton
			isChatActive={isClassroomActive && isChatEnabled}
			hasUnreadMessages={hasUnreadMessages}
			disabledChat={props.chatDisabled ?? true}
			{...props}
		/>
	);
};

export default ChatToolbarButton;
